// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.string().primaryKey(),
  organizationId: __t.string().name("organization_id"),
  customerId: __t.string().name("customer_id"),
  productId: __t.string().name("product_id"),
  priceId: __t.string().name("price_id"),
  status: __t.string(),
  quantity: __t.i32(),
  cancelAt: __t.option(__t.timestamp()).name("cancel_at"),
  canceledAt: __t.option(__t.timestamp()).name("canceled_at"),
  cancelAtPeriodEnd: __t.bool().name("cancel_at_period_end"),
  collectionMethod: __t.string().name("collection_method"),
  lastEventAt: __t.timestamp().name("last_event_at"),
  createdAt: __t.option(__t.timestamp()).name("created_at"),
  updatedAt: __t.option(__t.timestamp()).name("updated_at"),
});
